// Event details sourced from https://rojgar.mahaswayam.gov.in (Govt. of
// Maharashtra) on 2026-09-08. Designations sourced from Wikipedia on
// 2026-09-09 — verify against an official source before go-live.
// Shared by JobFairIntro.jsx (candidate-facing intro page) and the org-admin
// QR flyer download, so both stay in sync.
export const JOB_FAIR_CONFIG = {
  eventLogo: "/job-fair-event-logo.png",
  eventWordmark: "महास्वयम्",
  eventWordmarkTagline: "कौशल्य · रोजगार · उद्योजकता",
  eventName: "Rozgar Mahakumbh",
  eventNameMarathi: "रोजगार महाकुंभ",
  eventRegion: "Maharashtra",
  eventDate: "29 September 2026",
  eventDateMarathi: "२९ सप्टेंबर २०२६",
  department: "Department of Skill Development, Employment, Entrepreneurship & Innovation, Government of Maharashtra",
  departmentMarathi: "कौशल्य, रोजगार, उद्योजकता व नाविन्यता विभाग, महाराष्ट्र शासन",
  introText:
    "To provide maximum employment opportunities to youth across the state, more than 500 employment fairs and placement drives are being organized statewide on a single day.",
  introTextMarathi:
    "राज्यभरातील युवकांना रोजगाराच्या अधिकाधिक संधी उपलब्ध करून देण्यासाठी राज्यभर एकाच दिवशी ५०० पेक्षा जास्त रोजगार मेळावे/प्लेसमेंट ड्राईव्ह आयोजित करण्यात येत आहेत.",
  people: [
    {
      photo: "/job-fair-devendra-fadnavis.png",
      name: "Shri Devendra Fadnavis",
      title:
        "Hon'ble Chief Minister of Maharashtra — Home, Finance, Planning, Energy, Law & Judiciary, General Administration, and Information & Public Relations",
    },
    {
      photo: "/job-fair-pankaj-bhoyar.jpg",
      name: "Shri Pankaj Rajesh Bhoyar",
      title:
        "Minister of State, Government of Maharashtra — Home, Housing, School Education, Co-operation, and Mining; Guardian Minister, Wardha District",
    },
  ],
  thankYouText: "Thank you for your interest in Rozgar Mahakumbh.",
  bestOfLuckText: "Tap Apply Now to continue with your application best of luck!",
};
